/* eslint-disable import/default */

import './include-babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/RootShoppingCart';
const store = configureStore();

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('appShoppingCart')
);

if (module.hot) {
  module.hot.accept('./components/RootShoppingCart', () => {
    const NewRoot = require('./components/RootShoppingCart').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('appShoppingCart')
    );
  });
}
